import { SERVICE_ID } from '../../constants/services';
import serviceGroupHasService from '../serviceGroupHasService';

const quoteHasTransit = ({ service_groups: serviceGroups }): boolean =>
  serviceGroups.some(
    (serviceGroup) =>
      serviceGroupHasService(serviceGroup, SERVICE_ID.TRANSIT) || serviceGroupHasService(serviceGroup, SERVICE_ID.LDTRANSIT),
  );

export default quoteHasTransit;
